// extracted by mini-css-extract-plugin
export default {"description":"styles_description__sMG1M","steps":"styles_steps__LT7BG"};